import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: "app-exp-divergent-cell",
  standalone: true,
  imports: [],
  template: `
    <span class="cell-div">
      <span class="dv-bar">
        <span
          [style.left.%]="barLeft"
          [style.width.%]="barWidth"
          [style.background]="barColor"
        ></span>
      </span>
      <span class="dv-num" [class.pos]="value > 0" [class.neg]="value < 0">{{
        display
      }}</span>
    </span>
  `,
})
export class DivergentCellComponent implements OnChanges {
  @Input() value = 0;
  @Input() maxAbs = 0.05;
  @Input() format: (v: number) => string = (v) => (v * 100).toFixed(2) + "%";

  barLeft = 50;
  barWidth = 0;
  barColor = "#7C5CFF";
  display = "";

  ngOnChanges(): void {
    const max = Math.max(this.maxAbs, 0.0001);
    const t = Math.max(-1, Math.min(1, this.value / max));
    const half = Math.abs(t) * 50;
    if (t >= 0) {
      this.barLeft = 50;
      this.barWidth = half;
      this.barColor = "#00E5A0";
    } else {
      this.barLeft = 50 - half;
      this.barWidth = half;
      this.barColor = "#FF5C7A";
    }
    this.display = (this.value > 0 ? "+" : "") + this.format(this.value);
  }
}
